var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"status-view",class:_vm.statusClass},[_c('i',{class:_vm.statusIcon}),_c('span',[_vm._v(_vm._s(_vm.statusLabel))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }